import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/" },
    { path: "/:type" },
    { path: "/:type/:p1" },
    { path: "/:type/:p1/:p2" },
    { path: "/:type/:p1/:p2/:p3" },
    { path: "/:type/:p1/:p2/:p3/:p4" },
    { path: "/:type/:p1/:p2/:p3/:p4/:p5" },
  ]
});

